import React from 'react';
import { t } from 'Src/i18n';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { Button } from 'Components/frameworks/button/Button';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { AdditionalTransportComplexFlights } from 'Components/widgets/additional-transports/additional-transports-list/AdditionalTransportComplexFlights';
type AdditionalTransportListHeaderProps = {
  proposalId: string;
  totalTransports: number;
  onOpenLayer: () => void;
};
export const AdditionalTransportListHeader = ({
  proposalId,
  totalTransports,
  onOpenLayer,
}: AdditionalTransportListHeaderProps) => {
  const { trackClickEvent } = useTrackEvent();
  return (
    <div data-testid="AdditionalTransportListHeader" className="bg-white px-15 py-20 sm:px-60">
      <AdditionalTransportComplexFlights proposalId={proposalId} />
      <br />
      <span className="flex w-full justify-start font-brand text-24 font-semibold sm:text-28">
        {t('booking.transport.additionalTransports.others', {
          count: totalTransports,
        })}
      </span>
      <Button
        className="mt-15 block min-w-auto text-16 font-semibold md:hidden"
        color={COLORS.BLACK}
        colorBg={COLORS.WHITE}
        colorBorder={COLORS.BLACK}
        iconRight={{
          name: ICONS.FILTERS,
        }}
        onClick={() => {
          trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT_LAYER, {
            detail_click: 'advanced_filter_mobile',
          });
          onOpenLayer();
        }}
      >
        {t('faceting.filters.filtersButton')}
      </Button>
    </div>
  );
};
